import { useEffect, useRef, useState } from 'react'
import { Bell } from 'lucide-react'

/**
 * Notifications have no backend yet, so the bell shows an honest empty state
 * (no mock items, no unread badge). Wire to a real notifications API when available.
 */
export function NotificationBell() {
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!open) return
    const onDown = (e: PointerEvent) => {
      if (!ref.current?.contains(e.target as Node)) setOpen(false)
    }
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false)
    }
    document.addEventListener('pointerdown', onDown)
    document.addEventListener('keydown', onKey)
    return () => {
      document.removeEventListener('pointerdown', onDown)
      document.removeEventListener('keydown', onKey)
    }
  }, [open])

  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-label="Notifications"
        className="relative inline-flex items-center justify-center size-10 rounded-full text-black/70 hover:bg-black/[0.05] hover:text-black transition-colors focus-visible:outline-dashed focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black"
      >
        <Bell size={18} />
      </button>

      {open && (
        <div
          role="dialog"
          className="absolute right-0 top-12 z-50 w-[22rem] max-w-[calc(100vw-2rem)] bg-white border border-black/[0.08] rounded-xl shadow-soft-lg overflow-hidden"
        >
          <div className="flex items-center justify-between px-4 pt-3 pb-2 border-b border-black/[0.05]">
            <span className="font-540 text-body-sm">Notifications</span>
          </div>
          <div className="px-4 py-10 text-center">
            <p className="text-body-sm text-black/45">ยังไม่มีการแจ้งเตือน</p>
            <p className="text-[11px] text-black/35 mt-1">
              ระบบแจ้งเตือนจะเปิดใช้งานเมื่อ backend พร้อม
            </p>
          </div>
        </div>
      )}
    </div>
  )
}
